import React from "react";
import "./Register.css";

const RegistrationForm = () => {
  return (
    <div className="iframe-container">
      <iframe
        src="https://goatskarate.sportsmanago.pl/rekrutacja"
        title="Registration Form"
        className="registration-iframe"
        scrolling="no"
      />
    </div>
  );
};

export default RegistrationForm;
